import { Check } from "lucide-react";

const Choice = ({ label, selected, multi, onClick, testId }) => (
  <button type="button" className="choice" data-selected={selected} data-multi={multi} onClick={onClick} data-testid={testId}>
    <span className="choice-mark">{selected && <Check size={16} strokeWidth={3} />}</span>
    <span>{label}</span>
  </button>
);

export const QuestionField = ({ q, value, onChange }) => {
  if (q.type === "single")
    return (
      <div className="grid gap-3">
        {q.options.map((o, i) => (
          <Choice key={o} label={o} selected={value === o} onClick={() => onChange(value === o ? undefined : o)} testId={`${q.id}-option-${i}`} />
        ))}
      </div>
    );

  if (q.type === "multiple") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (o) => onChange(arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o]);
    return (
      <div className="grid gap-3 sm:grid-cols-2">
        {q.options.map((o, i) => (
          <Choice key={o} label={o} multi selected={arr.includes(o)} onClick={() => toggle(o)} testId={`${q.id}-option-${i}`} />
        ))}
      </div>
    );
  }

  if (q.type === "scale") {
    const nums = Array.from({ length: q.max - q.min + 1 }, (_, i) => q.min + i);
    return (
      <div>
        <div className="grid grid-cols-5 gap-3">
          {nums.map((n) => (
            <button key={n} type="button" className="scale-btn" data-selected={value === n} onClick={() => onChange(n)} data-testid={`${q.id}-scale-${n}`}>
              {n}
            </button>
          ))}
        </div>
        <div className="flex justify-between text-sm text-[#7A6B63] mt-2 px-1">
          <span>{q.lowLabel}</span>
          <span>{q.highLabel}</span>
        </div>
      </div>
    );
  }

  if (q.type === "number")
    return (
      <div className="flex items-center gap-4">
        <input type="number" inputMode="numeric" min="0" className="field max-w-[200px]" placeholder={q.placeholder} value={value ?? ""}
          onChange={(e) => onChange(e.target.value === "" ? undefined : Number(e.target.value))} data-testid={`${q.id}-input`} />
        <span className="text-[#7A6B63]">{q.unit}</span>
      </div>
    );

  return (
    <textarea className="field min-h-[130px] resize-y" rows={4} placeholder={q.placeholder} value={value ?? ""}
      onChange={(e) => onChange(e.target.value)} data-testid={`${q.id}-input`} />
  );
};
